import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ApiClient from "utils/ApiClient";
import config from 'config';
import {isEqual} from 'lodash';

import EnhancedLoginPrompt, { EnhancedLoginPromptHeading } from 'modules/Common/components/EnhancedLoginPrompt';
import AtrPlaceholderPrompt, { AtrPlaceholderPromptHeading } from './AtrPlaceholderPrompt';
import VideoPlayer from 'modules/Common/components/VideoPlayer';

require("./RaceVideoPlayer.scss");

const client = new ApiClient();

function defaultState() {
  return {
    autoPlayVideo: false,
    videoPlaying: false,
    videoUrlLoading: false
  };
}

@connect(state => ({ auth: state.common.auth,  atrPlaceholderStartTimeMs: state.common.atrVideo.placeholderTimeStamp }))
export default class RaceVideoPlayer extends Component {
  static propTypes = {
    videos: PropTypes.array.isRequired,
    atrPlaceholderStartTimeMs: PropTypes.number.isRequired,
    auth: PropTypes.shape({
      loggedIn: PropTypes.bool.isRequired,
      user: PropTypes.shape({
        ssoToken: PropTypes.string,
        customerId: PropTypes.string
      })
    }).isRequired,
    provider: PropTypes.string,
    showLoginBenefits: PropTypes.bool
  };

  constructor(...args) {
    super(...args);
    // The URL provided for At The Races is a getter for a short lived Video URL, so it must be stored transiently.
    this.state = defaultState();
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props, nextProps)) {
      this.setState(defaultState());
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);
  }

  getVideo() {
    const [video = {}] = this.lastVideo();
    return video;
  }

  hasVideo() {
    const {uri, media_type} = this.getVideoArtefact();
    return uri && (media_type === "Video");
  }

  getVideoArtefact() {
    const [{artefacts: [artefact = {}] = []} = {}] = this.lastVideo();
    return artefact;
  }

  lastVideo() {
    const {videos = []} = this.props;
    return videos.slice(-1); // only want the last (ie most recent) one - not possible via destructuring
  }

  loadVideoUri() {
    this.setState({
      autoPlayVideo: true,
      videoUrlLoading: true
    }, () => {
      this.fetchVideoData();
    });
  }

  getEventId() {
      // In the future we plan to alter the backend so that it just sends the eventId instead of a URL
      // but for the moment we need to extract the event id from the returned URL
      const eventIdStr = 'EventID=';
      const fullUrl = this.getVideoArtefact().uri;
      const eventIdPos = fullUrl.indexOf(eventIdStr) + eventIdStr.length;
      const eventIdEndPos = fullUrl.indexOf('&', eventIdPos);

      return fullUrl.substring(eventIdPos, eventIdEndPos);
  }

  // Only relevant for ATR videos
  fetchVideoData() {
    const headers = {'Authorization': this.props.auth.user.ssoToken,
                     'username':      this.props.auth.user.customerId};
    const params = {'eventId':        this.getEventId()};

    client.get(config.api.horseRacing.atrVideo, {params: params}, headers)
      .then((videoInfo) => {
        const {
          IsOK, // comes from ATR
          EventInfo: {
            Streams: [defaultStream = {}] = [], // get the default, the fist item or a blank
            Streams: streamList = [] // get the full list
          } = {}
        } = videoInfo;

        if (IsOK) {
          // Probably only one, but take the first if 2 or more match
          // If none match default to the first in the unfiltered list
          // If the unfiltered list is empty, yeild a blank
          let [{Url: videoPlaying} = defaultStream] = streamList.filter(s => (s.BitrateLevel == "Adaptive"));

          if (videoPlaying) {
            // this only ever gets called for ATR videos, which are always HLS
            videoPlaying = {
              src: videoPlaying,
              type: "application/x-mpegURL"
            };

            this.setState({
              videoPlaying,
              videoUrlLoading: false
            });
          }
        }
        else {
          this.onError();
        }
      });
  }

  hasVideoUri() {
    const {origin} = this.getVideo();
    return (origin !== "AT_THE_RACES") || this.state.videoPlaying;
  }

  getVideoUri() {
    if (this.hasVideoUri()) {
      return this.state.videoPlaying || this.getVideoArtefact().uri;
    }
  }

  loginPrompt() {
    return {
      className: "video-login",
      title: EnhancedLoginPromptHeading,
      body: <EnhancedLoginPrompt size="small" showLoginBenefits={this.props.showLoginBenefits}/>
    };
  }

  atrPlaceholderPrompt() {
      return {
          className: "video-login",
          title: AtrPlaceholderPromptHeading,
          body: <AtrPlaceholderPrompt size="small" />
      }
  }

  atrPlayButton() {
    return {
      loadSrc: () => this.loadVideoUri(),
      type: this.state.videoUrlLoading?'loading':'play'
    };
  }

  render() {
    const playerProps = {
      src: this.getVideoUri(),
      caption: this.getVideo().default_caption,
      autoPlay: this.state.autoPlayVideo
    };

    // short out video player component with placeholder if provided by ATR.
    const provider = this.props.provider || 'unknown';

    //show atr placeholder for ATR videos after jan 1st 2018
    const atrTimeStamp = parseInt(this.props.atrPlaceholderStartTimeMs);
    let showAtrPlaceholder = false;
    if (atrTimeStamp !== 0 && Date.now() >= atrTimeStamp) {
        showAtrPlaceholder = true;
    }

    if(showAtrPlaceholder && provider === "atr") {
        playerProps.prompt = this.atrPlaceholderPrompt();
        return <VideoPlayer {...playerProps} />;
    }

    const {origin} = this.getVideo();

    if (!this.props.auth.loggedIn) {
      playerProps.prompt = this.loginPrompt();
    }

    if ( showAtrPlaceholder && origin === "AT_THE_RACES") {
        playerProps.prompt = this.atrPlaceholderPrompt();
    }

    else if (!this.hasVideoUri()) {
      playerProps.button = this.atrPlayButton();
    }

    return <VideoPlayer {...playerProps} />;
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/RaceVideoPlayer.js